module.exports = __webpack_public_path__ + "img/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE.d2abcae5.svg";